import React from "react";
import PropTypes from "prop-types";
import ZoomToRegion from "../../../components/TooltipActions/ZoomToRegion";
import StructuralVariant from "../../../../../models/StructuralVariant";
import StructuralVariantsTitle from "./StructuralVariantsTitle";
import Track from "../../../models/Track";

function StructuralVariantsTooltip({ item, track, requestClose }) {
  if (!item || !track) return null;
  return (
    <StructuralVariantsTitle
      track={track}
      item={item}
      actions={
        <div className="tw-flex tw-items-center tw-text-sm">
          <ZoomToRegion
            region={item?.region}
            jumpTo={track.zoomService.jumpTo}
            requestClose={requestClose}
          />
        </div>
      }
    />
  );
}

StructuralVariantsTooltip.propTypes = {
  item: PropTypes.instanceOf(StructuralVariant).isRequired,
  track: PropTypes.instanceOf(Track).isRequired,
  requestClose: PropTypes.func.isRequired,
};

export default StructuralVariantsTooltip;
